import React from "react";
import ProductGrid from "../ProductGrid";

/**
 * Productos destacados de la home.
 *
 * Hoy está apagada por `SHOW_FEATURED_PRODUCTS` (src/config/features.js).
 * Queda entera para poder volver a prenderla sin rehacerla.
 */
const FeaturedProducts = ({ products }) => {

	if (!products || products.length === 0) return null;

	return (
		<section id="destacados" className="anchor-target bg-white py-16 lg:py-20">
			<div className="shell">
				<div className="mb-9 border-b border-line pb-5">
					<p className="eyebrow">Selección</p>
					<h2 className="mt-3 text-4xl tracking-headline font-semibold lg:text-5xl">Productos destacados</h2>
				</div>

				<ProductGrid products={ products } />
			</div>
		</section>
	);
};

export default FeaturedProducts;
